import { getAssetLayerKind } from './timelineModel';

/*
 * Dragging an asset from the media bin onto the timeline.
 *
 * The payload rides on a private mime type so a stray text drop is never
 * mistaken for a clip; the track kind is encoded in a *second* mime type
 * because `dragover` may only read the type list, not the data — and that is
 * where a track has to decide whether it can accept the thing being dragged
 * over it.
 */

export const ASSET_DRAG_MIME = 'application/x-mcapn-asset';

const assetDragKindMime = (kind) => `${ASSET_DRAG_MIME}-${kind}`;

export const setAssetDragPayload = (event, asset) => {
    const kind = getAssetLayerKind(asset?.FileType);
    if (!event?.dataTransfer || !kind) return;
    event.dataTransfer.effectAllowed = 'copy';
    event.dataTransfer.setData(ASSET_DRAG_MIME, JSON.stringify({
        fileName: asset.FileName,
        fileType: asset.FileType,
        kind,
    }));
    event.dataTransfer.setData(assetDragKindMime(kind), String(asset.FileName || ''));
    event.dataTransfer.setData('text/plain', String(asset.FileAlias || asset.FileName || ''));
};

export const readAssetDragPayload = (event) => {
    const raw = event?.dataTransfer?.getData?.(ASSET_DRAG_MIME);
    if (!raw) return null;
    try {
        const parsed = JSON.parse(raw);
        return parsed?.fileName ? parsed : null;
    } catch {
        return null;
    }
};

export const hasAssetDragOfKind = (event, kind) =>
    Boolean(kind) && Array.from(event?.dataTransfer?.types || []).includes(assetDragKindMime(kind));

export const hasFileDrag = (event) =>
    Array.from(event?.dataTransfer?.types || []).includes('Files');
